import { render, staticRenderFns } from "./frPrivacy.vue?vue&type=template&id=1eb797aa&scoped=true&"
import script from "./frPrivacy.vue?vue&type=script&lang=js&"
export * from "./frPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./frPrivacy.vue?vue&type=style&index=0&id=1eb797aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb797aa",
  null
  
)

export default component.exports